// src/components/chat/ErrorRetryBar.tsx
import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { Close, Refresh, ErrorOutline } from "@mui/icons-material";
import { useT } from "../../i18n/useT";

interface ErrorRetryBarProps {
  message: string;
  canRetry: boolean;
  onRetry: () => void;
  onDismiss: () => void;
  disabled?: boolean;
}

export const ErrorRetryBar: React.FC<ErrorRetryBarProps> = ({
  message,
  canRetry,
  onRetry,
  onDismiss,
  disabled,
}) => {
  const t = useT();
  return (
  <Box
    sx={{
      mx: 2,
      mb: 1,
      px: 1.5,
      py: 1,
      display: "flex",
      alignItems: "center",
      gap: 1,
      bgcolor: "error.main",
      color: "error.contrastText",
      borderRadius: 2,
      flexShrink: 0,
    }}
  >
    <ErrorOutline fontSize="small" />
    <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }}>
      {message}
    </Typography>
    {canRetry && (
      <Button
        size="small"
        onClick={onRetry}
        disabled={disabled}
        startIcon={<Refresh fontSize="small" />}
        sx={{
          color: "inherit",
          textTransform: "none",
          "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
        }}
      >
        {t('Retry')}
      </Button>
    )}
    <IconButton
      size="small"
      onClick={onDismiss}
      sx={{ color: "inherit" }}
      aria-label={t("Dismiss")}
    >
      <Close fontSize="small" />
    </IconButton>
  </Box>
);
};
